module.exports = __webpack_public_path__ + "assets/img/thirdPrize.bee6ed69.png";